export default "__VITE_ASSET__ZHFFwkCv__"